import {actions, ActionType} from './action';
import {
  createBasicReducerHandlers,
  createReducer,
  ReducerActionHelper,
} from '../../common/util/redux';
import {IEventModuleMap, IEventTypeV4, IModuleMapV4} from '../type';

export interface IStateEvent {
  eventPageTitle: string;
  eventModuleMap?: IEventModuleMap;
  eventId?: number;
  questCampaignId?: number;
  isExpired?: boolean;
  showLoading: boolean;
  bgColor?: string;
  bgColorRgb?: string;
  isScrollReset?: boolean;
  moduleMap: {[key in IEventTypeV4]?: IModuleMapV4};
}

const INITIAL_STATE: IStateEvent = {
  eventPageTitle: '',
  showLoading: true,
  moduleMap: {},
};

export default createReducer<IStateEvent, ReducerActionHelper<typeof actions>>(
  INITIAL_STATE,
  {
    ...createBasicReducerHandlers({
      setValueActionType: ActionType.SetValue,
      setPropertyValuesActionType: ActionType.SetPropertyValues,
    }),
    [ActionType.SetEventModuleMap]: (state, action) => {
      const {data, isExpired, showLoading, eventId, questCampaignId} =
        action.payload;
      state.eventPageTitle = data ? data.topModule.front.title : '';
      state.eventModuleMap = data;
      state.eventId = eventId;
      state.questCampaignId = questCampaignId;
      state.isExpired = isExpired;
      state.showLoading = showLoading;
      state.bgColor = data?.topModule.back.bgColor;
      state.bgColorRgb = data?.topModule.back.bgColorRgb;
    },
    [ActionType.SetEventModuleMapV4]: (state, action) => {
      state.moduleMap.event = action.payload;
    },
    [ActionType.SetEventInitData]: (state, action) => {
      const {bgColor} = action.payload;
      state.bgColor = bgColor;
      state.isScrollReset = true;
    },
    [ActionType.SetEventComments]: (state, action) => {
      const {comments} = action.payload;
      state.moduleMap.event?.moduleList?.forEach(item => {
        if (item.moduleType === 'comment') {
          item.commentList = comments;
        }
      });
    },
    [ActionType.SetContentSubscribe]: (state, action) => {
      const {isOn, index} = action.payload;
      state.moduleMap.event?.moduleList?.forEach(item => {
        if (item.moduleType === 'recommend' && item.recommendAnchorList) {
          item.recommendAnchorList[index].isLike = isOn;
        }
      });
    },
    [ActionType.SetMissionComplete]: (state, action) => {
      const {actionName, index} = action.payload;
      state.moduleMap.event?.moduleList?.forEach(item => {
        const {moduleType} = item;
        if (
          actionName === 'attendance_check' &&
          moduleType === 'missionAttendance' &&
          index !== undefined
        ) {
          item.attendanceList[index].isCompleted = true;
        } else if (
          (actionName === 'attendance_booking' &&
            moduleType === 'missionPreRequest') ||
          (actionName === 'content_booking' &&
            moduleType === 'missionContentBooking') ||
          (actionName === 'quiz_answer' && moduleType === 'missionQuiz')
        ) {
          item.isCompleted = true;
        }
      });
    },
  }
);
